import {
  LOGIN_ERROR,
  LOGIN_SUCCEEDED,
  SIGNUP_ERROR,
  SIGNUP_SUCCEEDED,
  CLEAR_AUTH,
  INVALID_EMAIL,
  INVALID_PASSWORD,
  LOGOUT_SUCCEEDED,
  LOADING_STATE,
  UNVERIFIED_EMAIL_ERROR,
  RESET_PASSWORD_SUCCEEDED,
  RESET_PASSWORD_FAILED,
  GET_GYMS_SUCCEEDED,
  GET_GYMS_ERROR
} from 'features/auth/ducks/types';

const INITIAL_STATE = {
  authMsg: '',
  emailMsg: '',
  passwordMsg: '',
  loginUser: false,
  loading: false,
  firstLogIn: false,
  unverifiedEmail: false,
  resetPasswordEmailSent: false,
  resetPasswordError: '',
  gyms: null
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === LOGIN_SUCCEEDED) {
    return {
      ...state,
      authMsg: '',
      authenticated: true,
      loginUser: false,
      firstLogIn: action.payload.firstLogIn,
      loading: false
    };
  } else if (action.type === SIGNUP_SUCCEEDED) {
    return { ...state, loginUser: true, loading: false };
  } else if (action.type === LOGIN_ERROR || action.type === SIGNUP_ERROR) {
    return { ...state, authMsg: action.payload, loading: false };
  } else if (action.type === CLEAR_AUTH) {
    return { ...state, emailMsg: '', passwordMsg: '', loading: false };
  } else if (action.type === INVALID_EMAIL) {
    return { ...state, emailMsg: action.payload, loading: false };
  } else if (action.type === INVALID_PASSWORD) {
    return { ...state, passwordMsg: action.payload, loading: false };
  } else if (action.type === UNVERIFIED_EMAIL_ERROR) {
    return {
      ...state,
      emailMsg: action.payload,
      unverifiedEmail: true,
      loading: false
    };
  } else if (action.type === LOGOUT_SUCCEEDED) {
    return undefined;
  } else if (action.type === LOADING_STATE) {
    return { ...state, loading: true, resetPasswordError: '' };
  } else if (action.type === RESET_PASSWORD_SUCCEEDED) {
    return { ...state, ...action.payload, loading: false };
  } else if (action.type === RESET_PASSWORD_FAILED) {
    return {
      ...state,
      resetPasswordEmailSent: false,
      ...action.payload,
      loading: false
    };
  } else if (action.type === GET_GYMS_SUCCEEDED) {
    return { ...state, gyms: action.payload };
  } else if (action.type === GET_GYMS_ERROR) {
    return { ...state, error: action.payload };
  } else {
    return state;
  }
}
